import { useHistory } from "react-router";

const NewIncidentInfoBox = () => {
  const history = useHistory();
  return (
    <div
      id="alert-additional-content-1"
      className={`mt-2 px-4 py-3 text-orange-800 border border-orange-300 rounded-lg bg-orange-50`}
      role="alert"
    >
      <div className="mb-2 text-sm">
        To report a new incident, click the button below.
      </div>
      <div className="flex">
        <button
          onClick={() => history.push("/create-new-incident")}
          type="button"
          className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-[#eb4c2d] rounded-full hover:opacity-75 transition-all focus:ring-4 focus:outline-none"
        >
          Create New Incident
        </button>
      </div>
    </div>
  );
};

export default NewIncidentInfoBox;
